import { useQuery } from '@affine/core/components/hooks/use-query';
import { SubscriptionService } from '@affine/core/modules/cloud';
import { SubscriptionPlan, tariffsQuery } from '@affine/graphql';
import { useLiveData, useService } from '@toeverything/infra';

/**
 * Fork billing: badge label and tier for the account plan tag.
 * Yookassa subscriptions show their tier name (Лайт / Профи / Макс).
 */
export const usePlanBadge = () => {
  const subscriptionService = useService(SubscriptionService);
  const subscription = useLiveData(subscriptionService.subscription.pro$);
  const isBeliever = useLiveData(subscriptionService.subscription.isBeliever$);
  const { data } = useQuery({ query: tariffsQuery }, { suspense: false });

  const tierId = subscription?.tier ?? null;
  const tier = tierId
    ? data?.tariffs?.tiers.find(item => item.id === tierId)
    : undefined;

  const label = isBeliever
    ? 'Believer'
    : tier
      ? tier.name
      : (subscription?.plan ?? SubscriptionPlan.Free);

  return {
    label,
    isBeliever,
    isPro: subscription?.plan === SubscriptionPlan.Pro,
    // free | lite | profi | max | <other paid tier>
    tier: isBeliever ? undefined : subscription ? (tierId ?? 'pro') : 'free',
  };
};
